var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWolverineLogoOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 40,
    viewBox: "0 0 168 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M59.4555 6.84609H63.7262L57.2961 22.5014L52.4975 13.5726L47.747 22.5014L41.3169 6.82215H45.5636L48.4907 15.2722L52.5215 6.08008L56.6003 15.2722L59.4555 6.84609Z",
    fill: "#FDB813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M64.8059 11.107C65.2138 10.1735 65.7656 9.33565 66.4854 8.64146C67.2052 7.94726 68.0449 7.42063 69.0286 7.03763C70.0123 6.65462 71.068 6.48706 72.1957 6.48706C73.3474 6.48706 74.403 6.67856 75.3627 7.03763C76.3225 7.42063 77.1862 7.94726 77.906 8.64146C78.6258 9.33565 79.1776 10.1495 79.5855 11.107C79.9694 12.0406 80.1853 13.0939 80.1853 14.2429C80.1853 15.3919 79.9934 16.4452 79.6095 17.4027C79.2256 18.3602 78.6738 19.198 77.954 19.8922C77.2342 20.5864 76.3944 21.137 75.4107 21.52C74.427 21.903 73.3713 22.0945 72.2197 22.0945C71.044 22.0945 69.9644 21.903 69.0046 21.52C68.0209 21.137 67.1812 20.5864 66.4614 19.8922C65.7416 19.198 65.1898 18.3602 64.8059 17.4027C64.422 16.4452 64.2301 15.3919 64.2301 14.2429C64.2061 13.0939 64.422 12.0646 64.8059 11.107ZM68.5248 16.5649C68.8607 17.2351 69.3645 17.7617 69.9884 18.1448C70.6122 18.5278 71.3559 18.7193 72.1957 18.7193C73.0354 18.7193 73.7552 18.5278 74.379 18.1448C75.0029 17.7617 75.5067 17.2351 75.8426 16.5649C76.1785 15.8946 76.3704 15.1286 76.3704 14.2429C76.3704 13.3572 76.2025 12.5912 75.8666 11.9209C75.5307 11.2507 75.0508 10.724 74.427 10.341C73.8032 9.95804 73.0594 9.76653 72.1957 9.76653C71.3559 9.76653 70.6122 9.95804 69.9884 10.341C69.3645 10.724 68.8607 11.2507 68.5248 11.9209C68.1889 12.5912 67.997 13.3572 67.997 14.2429C67.997 15.1047 68.1889 15.8946 68.5248 16.5649Z",
    fill: "#FDB813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M86.0395 6.84595V18.5755H91.9898V21.6395H82.4646V6.84595H86.0395Z",
    fill: "#FDB813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M101.371 6.84595H105.57L97.7479 22.5731L89.9502 6.84595H94.1249L97.7479 15.679L101.371 6.84595Z",
    fill: "#FDB813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M110.56 6.84595V21.6634H107.129V6.84595H110.56ZM109.504 6.84595H116.99V9.79029H109.504V6.84595ZM109.504 12.4234H116.558V15.296H109.504V12.4234ZM109.504 18.6951H116.99V21.6395H109.504V18.6951Z",
    fill: "#FDB813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M123.492 6.84595V21.6634H119.917V6.84595H123.492ZM122.149 6.84595H125.316C126.587 6.84595 127.643 7.06139 128.507 7.46833C129.347 7.87527 129.994 8.44978 130.426 9.16791C130.858 9.88604 131.074 10.7478 131.074 11.7053C131.074 12.6389 130.858 13.4767 130.426 14.2188C129.994 14.9369 129.347 15.5114 128.507 15.9184C127.667 16.3253 126.587 16.5407 125.316 16.5407H122.149V13.74H125.052C125.532 13.74 125.94 13.6682 126.3 13.5246C126.635 13.381 126.899 13.1655 127.091 12.8783C127.283 12.591 127.355 12.2319 127.355 11.825C127.355 11.4181 127.259 11.059 127.091 10.7717C126.899 10.4845 126.635 10.269 126.3 10.1015C125.964 9.95786 125.532 9.86211 125.052 9.86211H122.149V6.84595ZM127.331 14.9369L131.986 21.6395H127.787L123.636 14.9369H127.331Z",
    fill: "#FDB813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M137.264 6.84595V21.6634H133.617V6.84595H137.264Z",
    fill: "#FDB813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M154.107 6.84607V22.4056L143.838 13.3332V21.6636H140.407V6.104L150.652 15.1764V6.84607H154.107Z",
    fill: "#FDB813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M160.681 6.84595V21.6634H157.25V6.84595H160.681ZM159.625 6.84595H167.111V9.79029H159.625V6.84595ZM159.625 12.4234H166.679V15.296H159.625V12.4234ZM159.625 18.6951H167.111V21.6395H159.625V18.6951Z",
    fill: "#FDB813"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M43.8121 30.8796L43.7882 31.1669L42.7565 33.5128H41.3169L44.9878 25.5894L48.6587 33.5128H47.2191L46.1874 31.2147L46.1634 30.9035L44.9638 28.1028L43.8121 30.8796ZM43.2603 30.5205H46.7633L47.0032 31.5977H43.0204L43.2603 30.5205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M59.9593 25.9963V33.8957L54.441 28.4858V33.5127H53.1934V25.6133L58.6877 31.0232V25.9723H59.9593V25.9963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M63.0784 25.9963V33.5128H61.8308V25.9963H63.0784ZM62.6226 25.9963H66.4134V27.1214H62.6226V25.9963ZM62.6226 28.9407H66.1975V30.0418H62.6226V28.9407ZM62.6226 32.4117H66.4134V33.5367H62.6226V32.4117Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M73.6353 25.9963L71.356 29.6109L73.8032 33.5128H72.2437L70.6362 30.6163L68.9567 33.5128H67.4211L69.9164 29.6109L67.6851 25.9963H69.2206L70.6362 28.5337L72.0758 25.9963H73.6353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M74.499 25.9963H79.7535V27.1693H77.762V33.5128H76.4904V27.1693H74.499V25.9963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M80.1133 30.4487H82.3206V31.502H80.1133V30.4487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M86.9992 29.5871H90.6221C90.6461 30.1377 90.5742 30.6643 90.4062 31.143C90.2383 31.6218 90.0223 32.0766 89.6864 32.4357C89.3745 32.8187 88.9666 33.1059 88.5108 33.3214C88.0309 33.5368 87.5031 33.6565 86.9033 33.6565C86.3274 33.6565 85.8236 33.5608 85.3437 33.3693C84.8639 33.1777 84.456 32.9144 84.0961 32.5554C83.7362 32.1963 83.4723 31.7894 83.2803 31.3106C83.0884 30.8318 82.9924 30.3052 82.9924 29.7307C82.9924 29.1562 83.0884 28.6296 83.2803 28.1508C83.4723 27.6721 83.7602 27.2651 84.1201 26.9061C84.48 26.5709 84.8879 26.2837 85.3677 26.1161C85.8476 25.9485 86.3754 25.8289 86.9512 25.8289C87.4551 25.8289 87.887 25.9007 88.2948 26.0204C88.7027 26.164 89.0626 26.3315 89.3745 26.5949C89.6864 26.8342 89.9743 27.1454 90.1903 27.4806L89.1586 28.1748C88.9426 27.8157 88.6547 27.5284 88.2948 27.313C87.9349 27.0976 87.4791 27.0018 86.9512 27.0018C86.4714 27.0018 86.0155 27.1215 85.6316 27.3369C85.2478 27.5524 84.9119 27.8875 84.6959 28.2705C84.456 28.6775 84.336 29.1562 84.336 29.7068C84.336 30.2573 84.456 30.7361 84.6959 31.143C84.9358 31.55 85.2478 31.8851 85.6316 32.1006C86.0155 32.3399 86.4714 32.4357 86.9752 32.4357C87.3111 32.4357 87.623 32.3878 87.887 32.2921C88.1509 32.1963 88.3908 32.0766 88.5828 31.8851C88.7747 31.7175 88.9426 31.526 89.0626 31.2867C89.1826 31.0473 89.2785 30.8318 89.3505 30.5685H87.0472V29.5871H86.9992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M93.4053 25.9963V33.5128H92.1577V25.9963H93.4053ZM92.9255 25.9963H96.7164V27.1214H92.9255V25.9963ZM92.9255 28.9407H96.5004V30.0418H92.9255V28.9407ZM92.9255 32.4117H96.7164V33.5367H92.9255V32.4117Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M105.258 25.9963V33.8957L99.7635 28.4858V33.5127H98.5159V25.6133L104.01 31.0232V25.9723H105.258V25.9963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M108.377 25.9963V33.5128H107.129V25.9963H108.377ZM107.921 25.9963H111.712V27.1214H107.921V25.9963ZM107.921 28.9407H111.496V30.0418H107.921V28.9407ZM107.921 32.4117H111.712V33.5367H107.921V32.4117Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M114.759 25.9963V33.5128H113.487V25.9963H114.759ZM114.255 25.9963H115.815C116.366 25.9963 116.846 26.0921 117.23 26.2836C117.638 26.4751 117.95 26.7384 118.166 27.0975C118.382 27.4565 118.502 27.8635 118.502 28.3183C118.502 28.7731 118.382 29.204 118.166 29.5631C117.95 29.9221 117.638 30.1854 117.23 30.3769C116.822 30.5685 116.342 30.6642 115.815 30.6642H114.255V29.6109H115.767C116.055 29.6109 116.294 29.5631 116.534 29.4673C116.774 29.3716 116.918 29.2279 117.038 29.0364C117.158 28.8449 117.23 28.6295 117.23 28.3662C117.23 28.1029 117.158 27.8635 117.038 27.672C116.918 27.4805 116.75 27.3369 116.534 27.2411C116.318 27.1454 116.055 27.0975 115.767 27.0975H114.255V25.9963ZM116.414 29.9461L118.958 33.5367H117.422L115.023 29.9461H116.414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M121.813 30.8796L121.789 31.1669L120.757 33.5128H119.318L122.989 25.5894L126.659 33.5128H125.22L124.188 31.2147L124.164 30.9035L122.965 28.1028L121.813 30.8796ZM121.261 30.5205H124.764L125.004 31.5977H121.021L121.261 30.5205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M126.251 25.9963H131.506V27.1693H129.514V33.5128H128.243V27.1693H126.251V25.9963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M133.929 25.9963V33.5128H132.658V25.9963H133.929Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M135.681 28.1987C135.872 27.7199 136.16 27.313 136.496 26.9778C136.856 26.6188 137.264 26.3555 137.744 26.164C138.224 25.9725 138.728 25.8767 139.279 25.8767C139.855 25.8767 140.359 25.9725 140.839 26.164C141.319 26.3555 141.727 26.6188 142.087 26.9778C142.447 27.3369 142.71 27.7439 142.902 28.1987C143.094 28.6774 143.19 29.1801 143.19 29.7546C143.19 30.3052 143.094 30.8318 142.902 31.3106C142.71 31.7893 142.447 32.1963 142.087 32.5553C141.727 32.9144 141.319 33.1777 140.839 33.3692C140.359 33.5607 139.831 33.6565 139.279 33.6565C138.728 33.6565 138.2 33.5607 137.72 33.3692C137.24 33.1777 136.832 32.8905 136.472 32.5553C136.112 32.1963 135.849 31.7893 135.657 31.3106C135.465 30.8318 135.369 30.3052 135.369 29.7546C135.393 29.2041 135.489 28.6774 135.681 28.1987ZM137.048 31.143C137.264 31.55 137.576 31.8612 137.96 32.1005C138.344 32.3399 138.8 32.4357 139.279 32.4357C139.783 32.4357 140.215 32.316 140.599 32.1005C140.983 31.8612 141.295 31.55 141.511 31.143C141.727 30.7361 141.847 30.2813 141.847 29.7546C141.847 29.228 141.751 28.7732 141.535 28.3662C141.319 27.9593 141.031 27.6481 140.647 27.4087C140.263 27.1693 139.807 27.0736 139.303 27.0736C138.8 27.0736 138.368 27.1933 137.984 27.4087C137.6 27.6242 137.288 27.9593 137.072 28.3662C136.856 28.7732 136.736 29.228 136.736 29.7546C136.736 30.2813 136.832 30.7361 137.048 31.143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M151.396 25.9963V33.8957L145.901 28.4858V33.5127H144.654V25.6133L150.148 31.0232V25.9723H151.396V25.9963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M158.426 30.8796L158.402 31.1669L157.37 33.5128H155.931L159.602 25.5894L163.272 33.5128H161.833L160.801 31.2147L160.777 30.9035L159.578 28.1028L158.426 30.8796ZM157.874 30.5205H161.377L161.617 31.5977H157.634L157.874 30.5205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M164.448 26.1161C164.592 25.9724 164.76 25.9006 164.952 25.9006C165.168 25.9006 165.336 25.9724 165.48 26.1161C165.624 26.2597 165.696 26.4273 165.696 26.6188C165.696 26.8103 165.624 26.9778 165.48 27.1215C165.336 27.2651 165.168 27.3369 164.952 27.3369C164.76 27.3369 164.592 27.2651 164.448 27.1215C164.304 26.9778 164.232 26.8103 164.232 26.6188C164.232 26.4273 164.304 26.2597 164.448 26.1161ZM165.528 28.5817V33.5128H164.376V28.5817H165.528Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M35.3426 14.3867L34.6948 17.2114L34.191 17.9056L30.1602 20.3951L30.2801 24.7996L29.9682 25.6135L21.7147 33.8721L20.9229 33.5369L20.1312 33.8721L11.9016 25.6135L11.5897 24.7996L11.6857 20.3951L7.67888 17.9056L7.17503 17.2114L6.52723 14.3867L0.888916 19.9882L20.9229 40.0001L40.9809 19.9882L35.3426 14.3867Z",
    fill: "#FDB813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M20.755 10.2932L20.9229 10.4369L21.1149 10.2932L24.7138 10.8438L28.5766 7.63615L20.9229 0L13.2932 7.61221L17.1561 10.8438L20.755 10.2932Z",
    fill: "#FDB813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M22.0507 11.3943L20.923 10.4368L19.8193 11.3943V33.0819L20.923 33.5367L22.0507 33.0819V11.3943Z",
    fill: "#FDB813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M36.0468 20.0016L20.9307 4.92017L5.81456 20.0016L20.9307 35.083L36.0468 20.0016Z",
    fill: "#1E285F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M16.8202 12.0407L4.7998 1.96289L8.25477 16.9719L12.8374 19.7965L12.6934 24.8474L20.923 33.082V11.3944L16.8202 12.0407Z",
    fill: "#FDB813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M20.9232 23.8181L20.6113 23.9857L20.7312 24.632L20.3473 24.8475L20.1794 24.9432L19.7955 25.1587L19.6275 24.7996L19.4596 24.9911L19.4836 25.3502L19.1957 25.5656L18.5479 25.015C18.5479 25.015 18.5239 26.5949 19.1237 27.72C19.1237 27.72 17.8041 26.8822 17.5882 25.6614C17.3722 24.4405 17.972 24.1772 17.972 24.1772L20.1074 23.124L19.2677 22.2143L20.9951 21.8074V23.8181H20.9232Z",
    fill: "#1E285F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M20.9232 30.2095L20.4673 30.6164V30.1376L20.0355 30.377V29.8504C20.0355 29.8504 18.8358 29.1801 18.8598 27.8157C18.8598 27.8157 18.308 29.5392 19.2197 30.401C20.1314 31.2627 20.1314 31.0712 20.1314 31.0712L20.3714 31.6457H20.9472V30.2095H20.9232Z",
    fill: "#1E285F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M18.3559 17.4267L14.0132 15.0808L16.3405 19.605L20.1074 20.4668L18.3559 17.4267Z",
    fill: "#1E285F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M18.6437 18.432L16.5083 17.283L17.636 19.5092L19.4834 19.9401L18.6437 18.432Z",
    fill: "#FDB813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M20.9229 16.0383L18.9075 14.219L20.9229 17.0436V16.0383Z",
    fill: "#1E285F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M20.1553 22.2861L20.3232 22.741L20.8511 22.2861H20.1553Z",
    fill: "#FDB813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M13.1255 25.2783L13.5574 25.6853L13.6053 24.7996L13.1255 25.2783Z",
    fill: "#1E285F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M15.1648 27.3608L16.0285 28.2226L16.1485 26.3794L15.1648 27.3608Z",
    fill: "#1E285F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M13.7971 26.0204L14.8768 27.0976L15.0447 24.7996L13.7971 26.0204Z",
    fill: "#1E285F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M15.8845 12.3041L16.9642 13.3813L17.1082 11.0593L15.8845 12.3041Z",
    fill: "#1E285F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M19.7473 22.2861L15.3806 20.9456L19.7473 22.3818V22.2861Z",
    fill: "#1E285F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M19.9394 22.7888L14.7329 22.9803L19.9633 22.9085L19.9394 22.7888Z",
    fill: "#1E285F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M20.1073 22.4775L14.0371 21.9988L20.1553 22.5972L20.1073 22.4775Z",
    fill: "#1E285F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M25.0495 12.0407L37.07 1.96289L33.615 16.9719L29.0324 19.7965L29.1763 24.8474L20.9468 33.082V11.3944L25.0495 12.0407Z",
    fill: "#FDB813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M20.9468 23.8182L21.2587 23.9857L21.1387 24.632L21.5226 24.8475L21.6906 24.9432L22.0744 25.1587L22.2424 24.7996L22.4103 24.9911L22.3863 25.3502L22.6743 25.5656L23.3221 25.015C23.3221 25.015 23.3461 26.5949 22.7462 27.72C22.7462 27.72 24.0658 26.8822 24.2818 25.6614C24.4977 24.4405 23.8979 24.1772 23.8979 24.1772L21.7625 23.124L22.6023 22.2143L20.9468 21.7834V23.8182Z",
    fill: "#1E285F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M20.9468 30.2095L21.4027 30.6164V30.1376L21.8346 30.377V29.8504C21.8346 29.8504 23.0342 29.1801 23.0102 27.8157C23.0102 27.8157 23.5621 29.5392 22.6503 30.401C21.7386 31.2627 21.7386 31.0712 21.7386 31.0712L21.4987 31.6457H20.9229V30.2095H20.9468Z",
    fill: "#1E285F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M23.5142 17.4267L27.8569 15.0808L25.5296 19.605L21.7627 20.4668L23.5142 17.4267Z",
    fill: "#1E285F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M23.2262 18.432L25.3616 17.283L24.2339 19.5092L22.3865 19.9401L23.2262 18.432Z",
    fill: "#FDB813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M20.9468 16.0383L22.9622 14.219L20.9468 17.0436V16.0383Z",
    fill: "#1E285F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M21.6906 22.2861L21.5466 22.741L21.0188 22.2861H21.6906Z",
    fill: "#FDB813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M28.7445 25.2783L28.3126 25.6853L28.2646 24.7996L28.7445 25.2783Z",
    fill: "#1E285F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M26.7051 27.3608L25.8414 28.2226L25.7214 26.3794L26.7051 27.3608Z",
    fill: "#1E285F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M28.0726 26.0204L26.9929 27.0976L26.825 24.7996L28.0726 26.0204Z",
    fill: "#1E285F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M25.9854 12.3041L24.9057 13.3813L24.7378 11.0593L25.9854 12.3041Z",
    fill: "#1E285F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M22.1226 22.2861L26.4893 20.9456L22.1226 22.3818V22.2861Z",
    fill: "#1E285F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M21.9307 22.7888L27.1372 22.9803L21.9067 22.9085L21.9307 22.7888Z",
    fill: "#1E285F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M21.7386 22.4775L27.8088 21.9988L21.7146 22.5972L21.7386 22.4775Z",
    fill: "#1E285F"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWolverineLogoOrange);
export default __webpack_public_path__ + "static/media/Wolverine-Logo-Orange.0f476d2349d8bca0d1ac3705c7b59521.svg";
export { ForwardRef as ReactComponent };